import PropTypes from 'prop-types'

import GenericFlashcardHit from './GenericFlashcardHit'
import GenericVideoHit from './GenericVideoHit'
import LessonHit from './LessonHit'
import PostHit from './PostHit'
import CollectionHit from './CollectionHit'
import {
  collection,
  course,
  flashcard,
  flashcardCategory,
  lesson,
  poll,
  post,
  studyPack,
  video,
} from '../../constants/materialTypes'
import GenericCourseHit from './GenericCourseHit'
import PollHit from './PollHit'

const hitComponents = {
  [flashcard]: GenericFlashcardHit,
  [flashcardCategory]: GenericFlashcardHit,
  [lesson]: LessonHit,
  [post]: PostHit,
  [collection]: CollectionHit,
  [video]: GenericVideoHit,
  [studyPack]: GenericCourseHit,
  [course]: GenericCourseHit,
  [poll]: PollHit,
}

export default function AllMaterialsListHit({ hit }) {
  const { type } = hit
  const Component = hitComponents[type]

  return <Component hit={hit} showTypeLabel />
}

AllMaterialsListHit.propTypes = {
  hit: PropTypes.shape({
    type: PropTypes.oneOf([
      collection,
      flashcard,
      flashcardCategory,
      lesson,
      post,
      video,
      studyPack,
      course,
      poll,
    ]).isRequired,
  }).isRequired,
}
